import React from "react";
import { AuthenticateWithRedirectCallback } from "@clerk/react";
import LoadingScreen from "../../components/LoadingScreen";

const SSOCallback = () => (
  <>
    <AuthenticateWithRedirectCallback
      signInForceRedirectUrl="/user/dashboard"
      signUpForceRedirectUrl="/user/dashboard"
    />
    <LoadingScreen />
  </>
);

export default SSOCallback;
